<button nbButton size="tiny" status="primary" (click)="open()">Open Dialog</button>
